module.exports = __webpack_public_path__ + "img/20191030174138508.bcf80248.jpg";